/**
 * @generated SignedSource<<bc074b8c54d8bbcf7b2e99093ff9303e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveITPBanksList_query$data = {
  readonly itpBanks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly logo: string | null | undefined;
        readonly name: string | null | undefined;
        readonly providerId: string | null | undefined;
        readonly providerParticipantId: string | null | undefined;
      } | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentType": "PaymentActiveITPBanksList_query";
};
export type PaymentActiveITPBanksList_query$key = {
  readonly " $data"?: PaymentActiveITPBanksList_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveITPBanksList_query">;
};

import PaymentActiveITPBanksListRefetchQuery_graphql from './PaymentActiveITPBanksListRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "itpCode"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "search"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": PaymentActiveITPBanksListRefetchQuery_graphql
    }
  },
  "name": "PaymentActiveITPBanksList_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itpCode",
          "variableName": "itpCode"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        }
      ],
      "concreteType": "ITPBankConnection",
      "kind": "LinkedField",
      "name": "itpBanks",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ITPBankEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ITPBank",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "providerId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "providerParticipantId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "logo",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "9fd8e728284f8bf00ea5c314f2969526";

export default node;
